import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.heading',
		defaultMessage: 'Move users to Jira',
		description: 'Title of move users',
	},
	toggleLabel: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.toggle-label',
		defaultMessage: 'Add users into your project',
		description: 'Label of toggle button to add users to Jira project',
	},
	description: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.description',
		defaultMessage:
			'Enter a valid email address next to the user information to add a user to the project. Users without a corresponding email address won’t be imported.',
		description: 'Description for import Users',
	},
	descriptionForNotImportUsers: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.description-for-not-import-users',
		defaultMessage:
			'Adding users ensures that user information is displayed in issues, comments, and tags. Without users, assignee and reporter fields in Jira will be unassigned and user @mentions in comments will be converted to plain text.',
		description: 'Description for not import Users',
	},
	errorHeading: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.error-heading',
		defaultMessage: 'We couldn’t load this page',
		description: 'Heading for error message',
	},
	errorDescription: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.error-description',
		defaultMessage:
			'Try refreshing the page or wait for a few minutes before importing the project again.',
		description: 'Description for error message',
	},
	titleForNoUsers: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.title-for-no-users',
		defaultMessage: 'There are no users in the CSV file',
		description: 'title for no Users in uploaded file',
	},
	descriptionForNoUsers: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.description-for-no-users',
		defaultMessage:
			'You can proceed with the import by selecting <strong>Next</strong> or restart the import by uploading a CSV file with user information. If you choose to proceed without adding user information:<ul><li>Assignee and reporter fields will be unassigned.</li><li>User @mentions in comments will be converted to plain text. </li><li>Commenter names will change to Anonymous.</li></ul>',
		description: 'Description  for no Users in uploaded file',
	},
	newUserNotAllowedToImportBannerHeading: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.new-user-not-allowed-to-import-banner-heading',
		defaultMessage: 'Your permissions only allow you to add existing users',
		description: 'Header for not inviting new users',
	},
	newUserNotAllowedToImportBannerDescription: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.new-user-not-allowed-to-import-banner-description',
		defaultMessage:
			'If you’d like to add new users, contact an organization admin to invite them before moving ahead with your import or you can choose to continue with existing users. Any information of new users added here will not be imported.',
		description: 'Description for not inviting new users',
	},
	missingUsersSectionHeading: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.missing-users-section-heading',
		defaultMessage: 'Your configuration file contains user information that is missing in the CSV',
		description: 'Missing users section message heading',
	},
	missingUsersSectionDescription: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.missing-users-section-description',
		defaultMessage:
			'You can either proceed without adding these users or upload another configuration file to restart the import. <link>View missing user data</link>',
		description: 'Missing users section message description',
	},
	missingUsersModalHeading: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.missing-users-modal-heading',
		defaultMessage: 'Missing user data',
		description: 'Missing users modal heading',
	},
	missingUsersModalDescription: {
		id: 'project-create-importer-upload-flow.csv-user-mapping-screen.missing-users-modal-description',
		defaultMessage:
			'The following user information from your configuration file is missing in your CSV. If you choose to proceed, these users won’t be added to your project.',
		description: 'Missing users modal description',
	},
});
